import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { SwitchItem } from '@atpco/hub-ui';
import { PartnerType } from '../admin/admin-partners/partner-type.enum';

export interface NdcSeller {
  name: string;
  agency_number: string;
  id: any;
  tracking_code: string;
  airlines: any[];
  channels: any[];
  airlineCodes?: string[];
  channelNames?: string[];
  deleted?: any;
  statusSwitch?: SwitchItem;
}

export interface NdcSellerData {
  name: string;
  agency_number: string;
  partner_ids: any[];
}

@Injectable({ providedIn: 'root' })
export class NdcService {
  path: string = '/api';
  sellers: NdcSeller[] = [];

  constructor(private apiService: ApiService) { }

  getNdcSellers() {
    return this.apiService
      .get<{ data: NdcSeller[] }>(`${this.path}/v2/ndc_sellers`)
      .pipe(map((response) => response.data));
  }

  getNdcSeller(id: number) {
    return this.apiService
      .get<{ data: NdcSeller }>(`${this.path}/v2/ndc_sellers/${id}`)
      .pipe(map((response) => response.data));
  }

  createNdcSeller(data: NdcSellerData) {
    return this.apiService
      .post(`${this.path}/v2/ndc_sellers`, {
        ndc_seller: {
          name: data.name,
          agency_number: data.agency_number,
          partner_ids: data.partner_ids,
        },
      })
      .pipe(map((response) => response));
  }

  editNdcSeller(sellerId: number, data: NdcSellerData) {
    return this.apiService
      .put<{ data: NdcSeller }>(`${this.path}/v2/ndc_sellers/${sellerId}`, {
        ndc_seller: {
          name: data.name,
          agency_number: data.agency_number,
          partner_ids: data.partner_ids,
        },
      })
      .pipe(map((response) => response.data));
  }

  disableNdcSeller(sellerId: number) {
    return this.apiService
      .post(`${this.path}/v2/ndc_sellers/${sellerId}/disable`, {})
      .pipe(map((response) => response));
  }

  enableNdcSeller(sellerId: number) {
    return this.apiService
      .post(`${this.path}/v2/ndc_sellers/${sellerId}/enable`, {})
      .pipe(map((response) => response));
  }

  downloadCsvNdcSellers() {
    this.apiService.getCsv(`${this.path}/v2/ndc_sellers/download_csv`, 'ndc_sellers').subscribe();
  }

  deleteNdcSeller(id: number) {
    return this.apiService
      .delete<{ data: NdcSeller }>(`${this.path}/v2/ndc_sellers/${id}`)
      .pipe(map((response) => response.data));
  }

  getNdcSellersByType(type: PartnerType, id: string) {
    return this.apiService.get<{ data: NdcSeller[] }>(`${this.path}/v2/${type}s/${id}/ndc_sellers`).pipe(
      map((response) => response.data.filter((ndcSeller) => !ndcSeller.deleted)),
    );
  }

  getNdcSellerByType(type: string, partnerId: string, sellerId: string) {
    return this.apiService
      .get<{ data: NdcSeller }>(`${this.path}/v2/${type}/${partnerId}/ndc_sellers/${sellerId}`)
      .pipe(map((response) => response.data));
  }

  createNdcSellerByType(data: NdcSellerData, type: string, partnerId: string) {
    return this.apiService
      .post<{ data: NdcSeller }>(`${this.path}/v2/${type}/${partnerId}/ndc_sellers`, {
        ndc_seller: {
          name: data.name,
          agency_number: data.agency_number,
          partner_ids: data.partner_ids,
        },
      })
      .pipe(map((response) => response.data));
  }

  deleteNdcSellerByType(type: string, partnerId: string, sellerId: string) {
    return this.apiService
      .delete<{ data: NdcSeller }>(`${this.path}/v2/${type}/${partnerId}/ndc_sellers/${sellerId}`)
      .pipe(map((response) => response.data));
  }

  downloadCsvNdcSellersByType(type: PartnerType, partnerId: string) {
    this.apiService.getCsv(`${this.path}/v2/${type}s/${partnerId}/ndc_sellers/download_csv`, 'ndc_sellers').subscribe();
  }
}
